import jQuery from 'jquery';
import WidgetManager from './widget-manager';

const widgetManager = new WidgetManager();

jQuery(document).ready(() => {
    widgetManager.init();
    widgetManager.updateTotalPrice();
});
